import React from 'react';
import { useIntl } from 'react-intl';
import { warn } from '../../util/log';

import { DEFAULT_LOCALE_CODE } from '@snapchat/ads-l10n';

let intl;

const GlobalIntlProvider = ({ children }) => {
  intl = useIntl();
  return <React.Fragment>{children}</React.Fragment>;
};

/**
 * Helper that allows intl object to be accessed statically. Even though it must be configured dynamically.
 * We should try to avoid using it in general.
 */
export const getIntl = () => {
  if (!intl) {
    warn(
      'Must wrap IntlProvider with GlobalIntlProvider to ensure this method as has access to intl object.',
    );
    return undefined;
  }

  return intl;
};

export const getGlobalLocaleCode = () => {
  return intl?.locale || DEFAULT_LOCALE_CODE;
};

export default GlobalIntlProvider;
